import { graphql } from "gatsby"
import { gql } from "@apollo/client"

export const query = graphql`
  fragment eventEntry on Craft_event_default_Entry {
    uid
    title
    eventDate {
      ... on Craft_eventDate_dateRangeField {
        start
        end
      }
    }
    eventType
    eventDescription
    eventSignUpLink {
      target
      text
      type
      url
      element {
        ... on Craft_EntryInterface {
          uri
        }
      }
    }
    eventImage {
      ...mainFileUploadsAsset
    }
  }
`

export const eventEntry = gql`
  fragment eventEntry on event_default_Entry {
    uid
    title
    eventDate {
      ... on eventDate_dateRangeField {
        start
        end
      }
    }
    eventType
    eventDescription
    eventSignUpLink {
      target
      text
      type
      url
      element {
        uri
      }
    }
    eventImage {
      ...mainFileUploadsAsset
    }
  }
`
